var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9932 7.04879C17.9932 6.49979 17.5492 6.05279 16.9992 6.04979L9.0062 5.99979H9.0002C8.4502 5.99979 8.0042 6.44379 8.0002 6.99379C7.9962 7.54579 8.4412 7.99679 8.9942 7.99979L14.5522 8.03479L6.2932 16.2928C5.9022 16.6838 5.9022 17.3168 6.2932 17.7068C6.4882 17.9028 6.7442 17.9998 7.0002 17.9998C7.2562 17.9998 7.5122 17.9028 7.7072 17.7068L15.9952 9.41879L16.0002 15.0008C16.0002 15.5528 16.4482 15.9998 17.0002 15.9998H17.0012C17.5532 15.9998 18.0002 15.5508 18.0002 14.9988L17.9932 7.04879Z",
    fill: "#218567"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 13,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9932 7.04879C17.9932 6.49979 17.5492 6.05279 16.9992 6.04979L9.0062 5.99979H9.0002C8.4502 5.99979 8.0042 6.44379 8.0002 6.99379C7.9962 7.54579 8.4412 7.99679 8.9942 7.99979L14.5522 8.03479L6.2932 16.2928C5.9022 16.6838 5.9022 17.3168 6.2932 17.7068C6.4882 17.9028 6.7442 17.9998 7.0002 17.9998C7.2562 17.9998 7.5122 17.9028 7.7072 17.7068L15.9952 9.41879L16.0002 15.0008C16.0002 15.5528 16.4482 15.9998 17.0002 15.9998H17.0012C17.5532 15.9998 18.0002 15.5508 18.0002 14.9988L17.9932 7.04879Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_148)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/to.4312704bb953f3a8b52037b13a6e2aef.svg";
export { ForwardRef as ReactComponent };